<template>
  <div>
    <!-- Edit Modal -->
    <b-modal
      id="modal-edit"
      size="xl"
      centered
      :title="$store.state.modal.editLoker"
      header-bg-variant="warning"
      header-text-variant="light"
      @show="showModal()"
      class="custom-modal"
    >
      <!-- Stepper Header -->
      <div class="stepper d-flex justify-content-between mb-4">
        <div
          class="step"
          :class="{ active: step === 1, completed: step > 1 }"
        >
          <span>1</span>
          <p class="mb-0">{{ $store.state.tab.dataLoker }}</p>
        </div>
        <div class="line flex-grow-1"></div>
        <div
          class="step"
          :class="{ active: step === 2, completed: step > 2 }"
        >
          <span>2</span>
          <p class="mb-0">{{ $store.state.tab.syaratDokLoker }}</p>
        </div>
      </div>

      <!-- Step Content -->
      <div v-show="step === 1">
        <edit-tab-loker
          :data="data"
          @dataFromChild="fromData($event)"
          :divisi="divisi"
        />
      </div>
      <div v-show="step === 2">
        <edit-tab-dok-loker
          @dokumenFromChild="fromDokumen($event)"
          :dokumen="dokumen"
          :listDokumen="listDokumen"
        />
      </div>

      <!-- Footer -->
      <template #modal-footer>
        <b-button
          variant="outline-secondary"
          class="rounded-pill px-4"
          @click="$bvModal.hide('modal-edit')"
        >
          {{ $store.state.form.batal }}
        </b-button>

        <b-button
          v-if="step > 1"
          variant="outline-primary"
          class="rounded-pill px-4"
          @click="prevStep"
        >
          {{ $store.state.form.sebelumnya }}
        </b-button>

        <b-button
          v-if="step < 2"
          variant="primary"
          class="rounded-pill px-4"
          @click="nextStep"
        >
          {{ $store.state.form.selanjutnya }}
        </b-button>

        <b-button
          v-if="step === 2"
          :disabled="busy || !dataLoker || !dataDokumen || dataDokumen.length === 0"
          variant="success"
          class="rounded-pill px-4"
          v-b-modal.modal-konfirmasi-edit
        >
          {{ button }}
        </b-button>
      </template>
    </b-modal>

    <!-- Confirmation Modal -->
    <b-modal
      id="modal-konfirmasi-edit"
      size="md"
      centered
      :title="$store.state.modal.konfirmasiEditLoker"
      header-bg-variant="info"
      header-text-variant="light"
      class="custom-modal"
    >
      <p class="text-center font-weight-bold text-dark mb-3">
        {{ $store.state.text.konfirmasiDataLoker }}
      </p>

      <!-- Progress bar when saving -->
      <b-progress
        v-if="busy"
        height="20px"
        :value="100"
        variant="info"
        animated
        class="mb-3"
      >
        <strong class="text-white">Processing...</strong>
      </b-progress>

      <template #modal-footer>
        <b-button
          variant="outline-secondary"
          class="rounded-pill px-4"
          @click="batal"
        >
          {{ $store.state.form.batal }}
        </b-button>
        <b-button
          variant="primary"
          :disabled="busy"
          class="rounded-pill px-4"
          @click="create()"
        >
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import editTabLoker from "./editTabLoker.vue";
import editTabDokLoker from "./editTabDokLoker.vue";

export default {
  components: {
    editTabLoker,
    editTabDokLoker,
  },
  name: "modalEdit",
  props: ["data", "divisi", "edit", "dokumen"],
  data() {
    return {
      variant: "",
      msg: "",
      button: "Simpan",
      busy: false,
      dataLoker: "",
      dataDokumen: "",
      listDokumen: [],
      step: 1, // stepper state
    };
  },
  methods: {
    async showModal() {
      await this.getDokumen();
      this.dataLoker = this.data;
      this.dataDokumen = this.listDokumen;
      this.step = 1; // reset step when modal opens
    },
    async getDokumen() {
      let vm = this;
      const dokumen = await vm.$axios.get(
        "loker/listByKebutuhanLokerId/" + vm.data.lokerId
      );
      vm.listDokumen =
        dokumen.data.status == 200 ? dokumen.data.data : [];
    },
    fromData(data) {
      this.dataLoker = data;
    },
    fromDokumen(data) {
      this.dataDokumen = data.data;
    },
    nextStep() {
      if (this.step < 2) this.step++;
    },
    prevStep() {
      if (this.step > 1) this.step--;
    },
    create() {
      let vm = this;
      let tglAkhir = vm.$moment(vm.dataLoker.tanggalAkhirLoker);
      let bulkKebutuhan = [];
      for (let i = 0; i < vm.dataDokumen.length; i++) {
        let penampung = {};
        penampung.masterKebutuhanId = vm.dataDokumen[i].masterKebutuhanId;
        penampung.lokerId = vm.data.lokerId;
        penampung.id = Math.random() * 100 + vm.data.lokerId;
        bulkKebutuhan.push(penampung);
      }
      vm.busy = true;
      vm.button = "Mohon Tunggu...";
      vm.$axios
        .post("loker/update", {
          id: vm.dataLoker.lokerId,
          namaLoker: vm.dataLoker.namaLoker,
          keteranganLoker: vm.dataLoker.keteranganLoker,
          tanggalAkhirLoker: tglAkhir,
          masterPosisiId: vm.dataLoker.posisi
            ? vm.dataLoker.posisi.masterPosisiId
            : vm.dataLoker.masterPosisiId,
          bulkKebutuhan: JSON.stringify(bulkKebutuhan),
        })
        .then((res) => {
          vm.busy = false;
          vm.button = "Simpan";
          if (res.data.message == "sukses") {
            vm.$emit("alertFromChild", {
              variant: "success",
              msg: "BERHASIL MENGUBAH DATA LOWONGAN KERJA",
              showing: true,
            });
            vm.dataLoker = "";
            vm.dataDokumen = "";
            vm.$bvModal.hide("modal-edit");
            vm.$bvModal.hide("modal-konfirmasi-edit");
          } else {
            vm.$bvModal.hide("modal-edit");
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
          }
        })
        .catch(() => {
          vm.busy = false;
          vm.button = "Simpan";
          vm.$emit("alertFromChild", {
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
        });
    },
    batal() {
      this.$bvModal.hide("modal-konfirmasi-edit");
    },
  },
};
</script>

<style scoped>
/* Stepper styles */
.stepper .step {
  text-align: center;
  flex: 0 0 auto;
}
.stepper .step span {
  display: inline-block;
  width: 32px;
  height: 32px;
  line-height: 32px;
  border-radius: 50%;
  background: #d1d5db; /* gray */
  color: #fff;
  font-weight: bold;
}
.stepper .step.active span {
  background: #f59e0b; /* amber */
}
.stepper .step.completed span {
  background: #10b981; /* green */
}
.stepper .line {
  height: 2px;
  background: #d1d5db;
  margin: 16px 8px 0;
}
.stepper .step.active p,
.stepper .step.completed p {
  font-weight: bold;
  color: #111827;
}

/* Modal custom style */
.custom-modal .modal-header {
  background: linear-gradient(90deg, #f59e0b, #fbbf24);
  color: white !important;
  font-weight: bold;
  font-size: 18px;
}
.custom-modal .modal-footer {
  border-top: none;
}
.custom-modal .btn {
  transition: 0.3s;
}
.custom-modal .btn:hover {
  transform: scale(1.05);
}
/* make form inputs background white */
.custom-modal .form-control,
.custom-modal .b-form-group,
.custom-modal .b-form-textarea {
  background-color: #fff !important;
}
</style>
